// @ts-nocheck
/*** SPLIT TEXT ***/

export default class SplitText {
  elementId: string;
  wordList: Array<string>;
  splitMarkup: Array<HTMLElement>;
  refHTMLElement: HTMLElement;

  constructor(elementId: string) {
    this.elementId = elementId;
    this.refHTMLElement = document.querySelector(elementId);
    if (this.refHTMLElement) this.splitText();
  }

  splitText(): void {
    this.refHTMLElement.classList.add("split-text");
    this.wordList = this.refHTMLElement.innerText.split(" ");
    this.updatedMarkup();
  }

  updatedMarkup(): void {
    this.splitMarkup = this.wordList.map((word) => {
      const outerSpan = document.createElement("span");
      const innerSpan = document.createElement("span");

      innerSpan.classList.add("inner");
      innerSpan.textContent = word.trim() + " ";
      outerSpan.appendChild(innerSpan);

      return outerSpan;
    });
    this.setNewContent();
  }

  setNewContent(): void {
    while (this.refHTMLElement.firstChild) {
      this.refHTMLElement.removeChild(this.refHTMLElement.firstChild);
    }
    this.splitMarkup.forEach((spanElement) => {
      this.refHTMLElement.appendChild(spanElement);
    });

    this.animateText();
  }

  animateText(): void {
    gsap.registerPlugin(ScrollTrigger);

    this.refHTMLElement.classList.remove("hide");
    gsap.to(`${this.elementId} span.inner`, {
      duration: 1,
      translateY: 0,
      opacity: 1,
      stagger: 0.1,
      ease: "power.out",
      scrollTrigger: {
        trigger: this.elementId,
        toggleActions: "resume",
        start: "top bottom",
        // markers: true
      },
    });
  }
}
